import React from 'react';
import { 
  ChartBarIcon,
  CurrencyDollarIcon,
  BanknotesIcon,
  BuildingStorefrontIcon
} from '@heroicons/react/24/outline';

const Kapitani = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-3xl font-bold text-gray-900">Smart Farm</h1>
      </div>

      {/* Integration Status */}
      <div className="card">
        <div className="text-center py-12">
          <BuildingStorefrontIcon className="h-16 w-16 mx-auto text-gray-400 mb-4" />
          <h2 className="text-xl font-semibold text-gray-900 mb-2">Smart Farm Integration</h2>
          <p className="text-gray-600 mb-6">
            This module integrates with the existing Smart Farm management system.
          </p>
          <div className="inline-flex items-center px-4 py-2 bg-green-100 text-green-800 rounded-lg">
            <div className="w-2 h-2 bg-green-400 rounded-full mr-2"></div>
            System Connected
          </div>
        </div>
      </div>

      {/* Quick Stats from Smart Farm */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="card text-center">
          <ChartBarIcon className="h-8 w-8 mx-auto text-primary-600 mb-2" />
          <div className="text-2xl font-bold text-gray-900">Live Data</div>
          <div className="text-sm text-gray-600">Real-time Sync</div>
        </div>
        <div className="card text-center">
          <CurrencyDollarIcon className="h-8 w-8 mx-auto text-green-600 mb-2" />
          <div className="text-2xl font-bold text-gray-900">Analytics</div>
          <div className="text-sm text-gray-600">Financial Reports</div>
        </div>
        <div className="card text-center">
          <BanknotesIcon className="h-8 w-8 mx-auto text-blue-600 mb-2" />
          <div className="text-2xl font-bold text-gray-900">Management</div>
          <div className="text-sm text-gray-600">Farm Operations</div>
        </div>
      </div>
    </div>
  );
};

export default Kapitani;
